import { format, parse, isValid } from "date-fns";

export function formatDate(date, formatString) {
  return format(date, formatString || "MMMM d, yyyy");
}

export function parseDate(dateString, formatString) {
  const date = parse(
    dateString,
    formatString || "yyyy-MM-dd HH:mm:ss",
    new Date()
  );

  return isValid(date) ? date : null;
}

export function formatRange(startDate, endDate) {
  if (!startDate) return "";

  if (startDate && !endDate) {
    return `${formatDate(startDate)}`;
  } else if (startDate.getFullYear() === endDate.getFullYear()) {
    return `${formatDate(startDate, "MMMM d")}–${formatDate(endDate)}`;
  }

  return `${formatDate(startDate)}–${formatDate(endDate)}`;
}
